<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Edit Disciplinary Violation :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/employees/disciplinary-actions">
                            <i class="fa fa-gavel"></i> Disciplinary Actions
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/employees/disciplinary-actions#violations">
                            Violation Types
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <template v-if="disc_violation_id"><i class="fa fa-edit"></i> Edit</template>
                        <template v-else><i class="fa fa-plus"></i> Add</template>
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-9 col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row mb-2">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.violation_name }">Violation Name:</label>
                                <div class="col-sm-8">
                                    <input type="text" v-model="violation.violation_name" class="form-control" placeholder="Enter a Name for this Violation" :class="{'is-invalid': errors.violation_name }" />
                                    <span v-if="errors.violation_name" class="text-danger">
                                        <span v-for="error in errors.violation_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.penalty_name }">Penalty Name:</label>
                                <div class="col-sm-8">
                                    <input type="text" v-model="violation.penalty_name" class="form-control" placeholder="Enter Penalty Name" :class="{'is-invalid': errors.penalty_name }" />
                                    <span v-if="errors.penalty_name" class="text-danger">
                                        <span v-for="error in errors.penalty_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.bonus_disqual_time }">Safety Bonus Disqualification Time:</label>
                                <div class="col-sm-8">
                                    <input type="text" v-model="violation.bonus_disqual_time" class="form-control" placeholder="Enter Safety Bonus Disqualification Time" :class="{'is-invalid': errors.bonus_disqual_time }" />
                                    <span v-if="errors.bonus_disqual_time" class="text-danger">
                                        <span v-for="error in errors.bonus_disqual_time">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-success" v-on:click="saveViolation(this)" :disabled="saving">
                Save Disciplinary Violation
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                disc_violation_id: this.$route.params.id,
                violation: {},
                errors: {},
            }
        },

        methods: {

            getViolation: function() {
                //Get the data
                this.$http
                    .get('admin/disciplinary-violations/edit' + (this.disc_violation_id ? '/' + this.disc_violation_id : ''))
                    .then(response => {
                        //Set all the data
                        this.violation = response.data;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveViolation: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/disciplinary-violations/edit' + (this.disc_violation_id ? '/' + this.disc_violation_id : ''), this.violation)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Disciplinary Violation Saved');

                    //Return to main list?
                    this.$router.push('/employees/disciplinary-actions#violations');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            if(this.disc_violation_id)
            {
                //Get the Violation
                this.getViolation();
            }
            else
            {
                this.loading = false;
            }
        }
    }
</script>
